import { AllocationMedium } from './types';

export const INVALID_ROLE_ID = -1;

export const getInitialAllocatedMinutes = () => ({
  [AllocationMedium.Hard]: 0,
  [AllocationMedium.Soft]: 0,
});
